// extracted by mini-css-extract-plugin
module.exports = {"bold":"License_bold__1VqbD","img":"License_img__JyNs_"};